<template>
  <section class="user-info">
    <div class="row">
      <!-- User Details Section -->
      <div class="col-12 col-md-6">
        <div class="mb-2">
          <h5>{{$t('users.details.title')}}</h5>
        </div>
        <div class="row" v-if="user">
          <div class="col-md-12">
            <div>
              <b class="profile-details-label">{{$t('users.inputs.name')}}</b>
              <p class="profile-details-description">{{formattedUserTitleAndName}}</p>
            </div>
            <div>
              <b class="profile-details-label">{{$t('users.inputs.email')}}</b>
              <p>{{user.email}}</p>
            </div>
            <div>
              <b class="profile-details-label">{{$t('users.inputs.language')}}</b>
              <p>{{selectedLanguage($auth.user().language)}}</p>
            </div>
            <div>
              <b class="profile-details-label">{{$t('users.nickname')}}</b>
              <p> {{ user.nickname || '---' }}</p>
            </div>
            <div>
              <b class="profile-details-label mr-2">{{$t('users.inputs.created_at')}}</b>
              <va-popover
                v-if="user.created_at"
                :message="moment(user.created_at).format('YYYY-MM-DD HH:mm:ss')"
                placement="top">
                <i class="cursor-help fa fa-question-circle"></i>
              </va-popover>
              <p v-if="user.created_at" class="profile-details-description">{{user.created_at | readableDate}}</p>
              <p v-else class="profile-details-description">---</p>
            </div>
            <div>
              <b class="profile-details-label mr-2">{{$t('users.inputs.last_activity_at')}}</b>
              <va-popover
                v-if="user.logged_at"
                :message="moment(user.logged_at).format('YYYY-MM-DD HH:mm:ss')"
                placement="top">
                <i class="cursor-help fa fa-question-circle"></i>
              </va-popover>
              <p v-if="user.logged_at" class="profile-details-description">{{user.logged_at | readableDate}}</p>
              <p v-else class="profile-details-description">---</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End User Details Section -->

      <!-- Entity Details Section -->
      <div class="col-12 col-md-6">
        <div class="mb-2">
          <h5>{{$t('users.details.entity_details.title')}}</h5>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div>
              <b class="profile-details-label">{{$t('users.inputs.name')}}</b>
              <p class="profile-details-description">{{user.entity.name}}</p>
            </div>
            <div>
              <b class="profile-details-label">{{$t('users.details.entity_details.available_licenses')}}</b>
              <p v-if="user.entity.available_users_licenses > 0">
                {{user.entity.available_users_licenses}}
              </p>
              <p v-else>
                {{$t('users.details.entity_details.no_available_licenses')}}
              </p>
            </div>
            <div v-if="user.entity.lang">
              <b class="profile-details-label">{{$t('users.inputs.language')}}</b>
              <p>{{selectedLanguage(user.entity.lang)}}</p>
            </div>
            <div>
              <b class="profile-details-label mr-2">{{$t('users.inputs.created_at')}}</b>
              <va-popover
                v-if="user.entity.created_at"
                :message="moment(user.entity.created_at).format('YYYY-MM-DD HH:mm:ss')"
                placement="top">
                <i class="cursor-help fa fa-question-circle"></i>
              </va-popover>
              <p v-if="user.entity.created_at" class="profile-details-description">{{user.entity.created_at | readableDate}}</p>
              <p v-else class="profile-details-description">---</p>
            </div>
            <div>
              <b class="profile-details-label mr-2">{{$t('users.inputs.updated_at')}}</b>
              <va-popover
                v-if="user.entity.updated_at"
                :message="moment(user.entity.updated_at).format('YYYY-MM-DD HH:mm:ss')"
                placement="top">
                <i class="cursor-help fa fa-question-circle"></i>
              </va-popover>
              <p v-if="user.entity.updated_at" class="profile-details-description">{{user.entity.updated_at | readableDate}}</p>
              <p v-else class="profile-details-description">---</p>
            </div>
          </div>
        </div>
      </div>
      <!-- End Entity Details Section -->
    </div>
  </section>
</template>
<script>
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedUserTitleAndName: function () {
      if (!this.user) {
        return null
      }
      if (this.user.title) {
        return `${this.user.title} ${this.user.name}`
      }
      return `${this.user.name}`
    }
  },
  methods: {
    selectedLanguage: function (language) {
      switch (language.toUpperCase()) {
        case 'PT':
          return this.$t('profile.labels.portuguese')
        case 'EN':
          return this.$t('profile.labels.english')
        case 'ES':
          return this.$t('profile.labels.spanish')
      }
    },
  }
}
</script>
